export const getFormFiltro = () => ({
    txtFechaDe: {
        label: "Fecha de inicio:",
        value: null,
    },
    txtFechaA: {
        label: "Fecha de fin:",
        value: null,
    },
    txtEstatusConsulta: {
        label: "Estatus de consulta:",
        value: "",
    },
});

export const getModelConsulta = () => ({
    iIdConsulta: 0,
});

export const getMisConsultasColumns = () => [
    { title: "ID", field: "iIdConsulta" },
    { title: "Consulta inicio", field: "sFechaConsultaInicio" },
    { title: "Consulta fin", field: "sFechaConsultaFin" },
    { title: "Nombre", field: "name" },
    { title: "Estatus de consulta", field: "sEstatusConsulta" },
    { title: "Detalle", field: "sDetalle", hideFilter: true, hideSort: true },
];
